/**
 * Function to convert a first letter of the word to uppercase
 * @param {any} value value
 * @returns {string} string
 */
function capitalizeFirstLetter(value: string) {
  return value.charAt(0).toUpperCase() + value.slice(1);
}

/**
 * Function to update file name
 * @param {any} fileName fileName
 * @returns {string} sanitized file name
 */
function SanitizeFileName(fileName: string) {
  return fileName.replace(/[^a-zA-Z0-9]/g, '_');
}

// Change default export when adding more functions
export { capitalizeFirstLetter, SanitizeFileName };
